import React from "react";
import { Box } from "@mui/material";
import { ThreeDot } from "react-loading-indicators";
import { LAYERS } from "../utils/layering";
import { NEUTRAL, VIOLET } from "../styles/brandTokens";

export interface GlobalLoadingOverlayProps {
  /**
   * `content` (default) fills the nearest positioned ancestor — in the app shell
   * that is `.theo-app-shell-main` — so the sidebar and topbar stay clickable
   * while a page loads. Only use `app` before the shell exists (auth checks),
   * where there is genuinely nothing else to navigate to.
   */
  variant?: "content" | "app";
}

/**
 * Covers the area that is loading, not the whole product. A viewport-fixed scrim
 * made every page load trap the user: the nav was visibly rendered but swallowed
 * every click until the request finished.
 */
const GlobalLoadingOverlay = ({ variant = "content" }: GlobalLoadingOverlayProps) => (
  <Box
    role="status"
    aria-live="polite"
    aria-label="Loading"
    sx={{
      position: variant === "app" ? "fixed" : "absolute",
      inset: 0,
      // A wash in the page tint rather than black: it reads as "this panel is
      // busy" instead of dimming the entire product.
      bgcolor: `${NEUTRAL.page}B8`,
      zIndex: LAYERS.globalLoading,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <ThreeDot color={VIOLET.theo} />
  </Box>
);

export default GlobalLoadingOverlay;
